import { Injectable } from '@angular/core';
import { Adapter } from '../../../../interfaces/Adapter';
import { TemporaryPreferredTimeOff } from '../../../models/employee/TemporaryPreferredTimeOff';
import { EmployeeOneTimePreferredTimeOffResponse } from '../../../../interfaces/response/EmployeeResponse';

/**
 * An adapter converts temporary preferred time off HTTP response to domain object.
 */
@Injectable({
  providedIn: 'root'
})
export class TemporaryPreferredTimeOffAdapter implements Adapter<Map<string, TemporaryPreferredTimeOff>> {

  /**
   * Converts temporary preferred time off HTTP response to {@link TemporaryPreferredTimeOff}.
   * @param item temporary preferred time off HTTP response.
   */
  adapt(item: EmployeeOneTimePreferredTimeOffResponse[]): Map<string, TemporaryPreferredTimeOff> {
    if (!item) {
      return null;
    }
    const result = new Map<string, TemporaryPreferredTimeOff>();
    item.forEach($item => {
      const preferredTimeOff = $item.preferredTimeOff;
      result.set(
        $item.date,
        new TemporaryPreferredTimeOff(
          preferredTimeOff.reason,
          preferredTimeOff.startTime,
          preferredTimeOff.endTime,
          $item.date
        ));
    });
    return result;
  }
}
